import React from 'react'
import { useTranslation } from 'react-i18next'
import FactGrid from '../FactGrid'

const ACCESS_KEYS = ['consumerCollect', 'driverDeliver', 'driverPickup']

// The registry shows this section to iBoxen only.
//
// The same grid the location facts above use, so the box reads as one list rather than two that
// happen to sit together. Both of these are wide: a line of three access types and a list of keys
// have nothing to gain from a quarter of a box.
export default function Access({ parcel }) {
  const { t } = useTranslation('parcels')

  const facts = [
    parcel.access && {
      key: 'access',
      label: t('access'),
      wide: true,
      value: ACCESS_KEYS.map(
        (key) =>
          `${t(`accessTypes.${key}`)}: ${
            parcel.access[key] ? t('yes') : t('no')
          }`
      ).join(' · '),
    },
    {
      key: 'sharedKeys',
      label: t('sharedKeys'),
      wide: true,
      value: parcel.sharedKeys?.length
        ? parcel.sharedKeys.join(', ')
        : t('noSharedKeys'),
    },
  ].filter(Boolean)

  return <FactGrid facts={facts} />
}
